import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPlan: null,
  isPaidPlan: false,
  loading: true,
};

const currentPlanSlice = createSlice({
  name: "currentPlan",
  initialState,
  reducers: {
    setCurrentPlan: (state, action) => {
      state.currentPlan = action.payload;
    },
    setIsPaidPlan: (state, action) => {
      state.isPaidPlan = action.payload;
    },
    setPlanLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setCurrentPlan, setPlanLoading, setIsPaidPlan } = currentPlanSlice.actions;

export default currentPlanSlice.reducer;
